import { createSelector } from 'reselect';
const selectTranslationState = (state) => state.language;
export const selectLanguage = createSelector([selectTranslationState], (translationState) => translationState.language);
export const selectMessages = createSelector([selectTranslationState], (translationState) => translationState.messages);
export const selectTranslationsLoaded = createSelector([selectTranslationState], (translationState) => translationState.translationsLoaded);
